import { useMemo } from "react";

import { customCssSelector, useAppSelector } from "../../../../store";
import rootElement from "../../../../rootElement";

export function useFontMetrics() {
  const customCss = useAppSelector(customCssSelector);

  return useMemo(
    () => {
      const wrapper = rootElement.querySelector('#wrapper');
      if (!wrapper) return undefined;

      return getComputedStyle(wrapper);
    },
    [customCss], // eslint-disable-line react-hooks/exhaustive-deps
  );
}

export function useFontSize() {
  const metrics = useFontMetrics();
  if (!metrics) return 1;
  return +metrics.fontSize.replace('px', '') / 16; // Convert from `px` to `em`
}

export function useFontWeight() {
  const metrics = useFontMetrics();
  if (!metrics) return 400;
  const fontWeight = metrics.fontWeight;
  const numericWeight = +fontWeight;
  if (!Number.isNaN(numericWeight)) return numericWeight;

  const fontWeightMap: Record<string, number> = {
    'normal': 400,
    'bold': 700,
    'lighter': 100,
    'bolder': 700,
  };

  return fontWeightMap[fontWeight.toLowerCase()] ?? 400;
}
